// extracted by mini-css-extract-plugin
module.exports = {"root":"Consent_root__2lw87","content":"Consent_content__19q_z","footer":"Consent_footer__1AVF7"};